export const CONFIGURATION_FILENAMES = [
  'microfrontends.jsonc',
  'microfrontends.json',
] as const;
